import { render } from "./calendar_padrao.vue?vue&type=template&id=707ad202"
import script from "./calendar_padrao.vue?vue&type=script&lang=js"
export * from "./calendar_padrao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__